<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);

const showSidebar = ref(false);
const toggleSidebar = () => (showSidebar.value = !showSidebar.value);
const closeSidebar = () => (showSidebar.value = false);

const isMobile = ref(false);
const isTablet = ref(false);

// Screen detection
const checkScreen = () => {
  const width = window.innerWidth;
  isMobile.value = width < 640;
  isTablet.value = width >= 640 && width < 1024;
};

onMounted(() => {
  checkScreen();
  window.addEventListener("resize", checkScreen);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkScreen);
});
</script>

<template>
  <button
    class="btn btn-icon d-xl-none position-fixed start-3 z-index-1031"
    :class="{
      'top-1': isMobile,
      'top-3': isTablet || (!isMobile && !isTablet)
    }"
    @click="toggleSidebar"
    style="z-index: 1041"
  >
    <i class="fas fa-bars text-primary"></i>
  </button>

  <div
    v-if="showSidebar"
    class="position-fixed top-0 start-0 w-100 h-100 d-xl-none"
    style="
      backdrop-filter: blur(2px);
      background-color: rgba(255, 255, 255, 0.1);
      z-index: 1040;
    "
    @click="closeSidebar"
  ></div>

  <aside
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 ms-3 my-3 border-radius-xl bg-gradient-primary"
    :class="[
      isRTL ? 'fixed-end me-3' : 'fixed-start ms-3',
      layout === 'landing' ? 'bg-transparent shadow-none' : '',
      sidebarType,
      showSidebar ? 'd-block' : 'd-none d-xl-block'
    ]"
    id="sidenav-main"
    style="z-index: 1041"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-xl-none"
        aria-hidden="true"
        @click="closeSidebar"
      ></i>

      <router-link class="m-0 navbar-brand" to="/">
        <img
          src="@/assets/img/logos/arbLogo.png"
          class="navbar-brand-img h-100"
          alt="main_logo"
        />
      </router-link>
    </div>

    <hr class="mt-0 horizontal dark" />

    <sidenav-list @close-mobile-sidebar="closeSidebar" />
  </aside>
</template>
